export function getNotificationNavigationTarget(
  link: string | null | undefined
): string | null {
  const normalizedLink = normalizeNotificationLink(link);
  if (!normalizedLink) return null;

  if (/^https?:\/\//.test(normalizedLink)) {
    try {
      const url = new URL(normalizedLink);
      const currentOrigin =
        typeof window !== "undefined" ? window.location.origin : null;
      if (currentOrigin && url.origin === currentOrigin) {
        return `${url.pathname}${url.search}${url.hash}`;
      }
    } catch {
      return normalizedLink;
    }
    return normalizedLink;
  }

  if (normalizedLink.startsWith("/")) {
    return normalizedLink;
  }

  return `/#${normalizedLink.replace(/^#/, "")}`;
}

function normalizeNotificationLink(
  link: string | null | undefined
): string | null {
  if (!link) return null;

  const raw = link.trim();
  if (!raw) return null;

  const legacyRelative = raw.match(/^(?:#\/|\/#\/|\/)?sales\/quotes\/(\d+)(.*)$/);
  if (legacyRelative) {
    return `/quotes/${legacyRelative[1]}${legacyRelative[2] || ""}`;
  }

  if (/^https?:\/\//.test(raw)) {
    try {
      const url = new URL(raw);
      const currentOrigin =
        typeof window !== "undefined" ? window.location.origin : null;
      if (!currentOrigin || url.origin !== currentOrigin) return raw;

      const legacyPath = url.pathname.match(/^\/sales\/quotes\/(\d+)(.*)$/);
      if (legacyPath) {
        return `/quotes/${legacyPath[1]}${legacyPath[2] || ""}${url.search}`;
      }

      const legacyHash = url.hash.match(/^#\/sales\/quotes\/(\d+)(.*)$/);
      if (legacyHash) {
        return `/quotes/${legacyHash[1]}${legacyHash[2] || ""}`;
      }
    } catch {
      return raw;
    }
  }

  return raw;
}
